<template>
    <v-group>
      <template v-for="layer in layers">
        <template v-if="isVisible(layer)">
            <text-bundled 
            v-if="layer.type==='Text'"
            :key="layer.id"
            :layer="{ ...layer }"
            :artworkID="artwork[0].id"
            :scale="scale"
            :offset="offset"
            :parentRatio="parentRatio"
            :rotation="rotation"
            :personalized="personalized"
            :artworks="artwork"
            />
            <image-bundled 
            v-if="layer.type === 'Image'"
            :layer="layer"
            :key="layer.id"
            :artworkID="artwork[0].id"
            :scale="scale"
            :offset="offset"
            :parentRatio="parentRatio"
            :rotation="rotation"
            :personalized="personalized"
            />
            <group-bundled
            v-if="layer.type === 'Group'"
            :layer="layer"
            :key="layer.id"
            :artworkID="artwork[0].id"
            :scale="scale"
            :offset="offset"
            :parentRatio="parentRatio"
            :rotation="rotation"
            :personalized="personalized"
            :artworks="artwork"
            />
        </template>
      </template>
    </v-group>
</template>

<script>
import ImageBundled from './ImageBundled';
import TextBundled from './TextBundled';
import { max, map, get } from 'lodash'
import { checkCondition, isMoonColorVisible } from '@/helper/helper'
import GroupBundled from './GroupBundled';

export default {
  components: {ImageBundled, TextBundled, GroupBundled },
   name: "artwork-bundled",
   props: {
      artwork: {
        type: Array,
        required: true
      },
      width: {
        type: Number
      },
      offset: {
        type: Object,
        default() {
          return { x: 0, y: 0, offsetX: 0 }
        }
      },
      rotation: {
        type: Number,
        default() {
          return 0
        }
      },
      parentRatio: {
        type: Number,
        default() {
          return 1
        }
      },
      personalized: {
        type: Object,
        default(){
          return {}
        }
      }
   },
   computed: {
      scale() {
        const { artwork, width, ratio } = this
        if (!width) {
          return 1
        }
        return width / (artwork[0].width * ratio)
      },
      layers() {
        return this.artwork[0].templates[0].layers
      },
      ratio() {
        var ratio = 1
        if (this.artwork[0].width && this.artwork[0].height) {
          var r = max([this.artwork[0].width, this.artwork[0].height])
          var res = 10
          for (; res > 1; res--) {
            if (r * res <= 10000) {
              break
            }
          }
          ratio = res / 10
        }
        return ratio
      },
      stageConfig() {
        const { artwork, scale, ratio } = this
        return {
          width: Math.round(artwork[0].width * ratio * scale),
          height: Math.round(artwork[0].height * ratio * scale)
        }
      },
      artworkLoading() {
        const { loadings, artwork } = this
        if (artwork[0]) {
          return map(get(loadings, artwork[0].id, {})).some(
            loading => loading === true
          )
        }
        return null
      }
   },
   created(){
   },
   methods: {
      checkCondition(layer) {
        const { personalized, artwork } = this
        const data = get(personalized, artwork[0].id)
        return checkCondition(layer, data)
      },
      isVisible(layer) {
        if (
          get(layer, 'personalized.enable', false) !== true &&
          layer.excludeMockup === true
        ) {
          return false
        }
        const { personalized, artwork, layers } = this
        const data = get(personalized, artwork[0].id)
        return this.checkCondition(layer) && isMoonColorVisible(layer, layers, data)
      }
   }
}
</script>



// WEBPACK FOOTER //
// src/components/BundledProduct/ArtworkBundled/ArtworkBundled.vue